import React from 'react';
import { remark } from 'remark';
import remarkHtml from 'remark-html';

function splitQuestionsAndAnswers(text) {
    const pairs = [];
    const regex = /- question: (.*?)\n\s*answer: (.*?)\n/g;
    let match;

    while ((match = regex.exec(text)) !== null) {
        const question = match[1].trim();
        const answer = match[2].trim();
        pairs.push({ question, answer });
    }

    return pairs;
}


const Faq = (props) => {
    const { children } = props
    const questions = splitQuestionsAndAnswers(children[0])
    const renderMarkdown = (content) => {
        const processedContent = remark().use(remarkHtml).processSync(content).toString();
        return { __html: processedContent };
    };
    return (
        <div itemscope="itemscope" itemtype="https://schema.org/FAQPage" className="article-faq">
            {questions.map((faq, i) => {
                const { question, answer } = faq
                return (
                    <div key={i} itemscope="itemscope" itemprop="mainEntity" itemtype="https://schema.org/Question" className='bg-zinc-100 py-2 px-4 rounded first:mt-10 mb-5 last:mb-10'>
                        <h4 itemprop="name" className='font-bold text-xl mb-2' dangerouslySetInnerHTML={renderMarkdown(question)}></h4>
                        <div itemscope="itemscope" itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                            <div itemprop="text" className='text-lg' dangerouslySetInnerHTML={renderMarkdown(answer)}>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default Faq;